import { css } from '@emotion/css';
import { m } from '@snapchat/snap-design-system-marketing';

export const errorMessageCss = css`
  align-items: flex-start;
  display: flex;
  font-size: ${m('--p3-mobile-font-size')};
  gap: ${m('--spacing-xxs')};
  line-height: 140%;
  padding: ${m('--spacing-m')} 0;
  white-space: pre-wrap;
  width: 100%;
`;

export const errorMessageIconCss = css`
  fill: ${m('--semantic-error-color')};
  min-width: 20px;
  width: 20px;
`;
